import React, { useState, useRef, useCallback } from 'react';

import { httpMethods, useFetchData } from 'utils/hooks/use-fetch-data.js';
import { useOutsideClick } from 'utils/hooks/use-outside-click';
import * as endpoints from 'utils/api/endpoints';
import { ReleaseNoteWrapper, IconContainer } from './release-note-styled-components.js';
import BellIcon from 'components/svg-icons/bell-icon.js';
import ReleaseNoteModel from './release-note-model.js';

const ReleaseNote = () => {
    const [isDropdownOpened, setIsDropdownOpened] = useState(false);
    const [notificationProcessing, setNotificationProcessing] = useState(false);
    const [releaseData, setReleaseData] = useState(null);
    const dropdownRef = useRef(null);
    const profilePanelRef = useRef(null);

    const toggleDropdown = () => {
        setIsDropdownOpened(opened => !opened);
    };

    const closeDropdown = useCallback(() => setIsDropdownOpened(false), []);
    // A press outside the bell and the notes closes them (the bell toggles them itself)
    useOutsideClick({ ref: [dropdownRef, profilePanelRef], callback: closeDropdown, isEnabled: isDropdownOpened });

    const handleReleaseNoteResponse = useCallback(
        data => {
            if (!data) {
                return;
            }
            setReleaseData(data);
        },
        [setReleaseData]
    );

    //Get Latest Release Note
    useFetchData({
        method: httpMethods.get,
        url: endpoints.getLastReleases,
        enableCache: true,
        processingSetter: setNotificationProcessing,
        responseHandler: handleReleaseNoteResponse
    });

    if (notificationProcessing) {
        return null;
    }

    return (
        <ReleaseNoteWrapper>
            <div ref={profilePanelRef}>
                <IconContainer onClick={toggleDropdown}>
                    <BellIcon />
                </IconContainer>
            </div>
            {!!isDropdownOpened && <ReleaseNoteModel ref={dropdownRef} releaseData={releaseData} />}
        </ReleaseNoteWrapper>
    );
};

export default ReleaseNote;
